export const GTM_EVENTS_NAME = {
  FIRST_PURCHASE: 'FirstPurchase',
  PURCHASE: 'Purchase',
  ON_SIGNUP_COMPLETE: 'Sign-Up',
}
